/* Hlavni stranka: tocici se slovo v nadpisu uvodni fotky ("Plachtove haly na miru pro ...") */
(function () {
  if (location.pathname !== '/' && location.pathname !== '/cs' && location.pathname !== '/cs/') return;
  var WORDS = ['sklad', 'seno', 'techniku', 'koně', 'dobytek', 'tenis', 'lodě', 'výrobu', 'siláž', 'cokoli'];
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var el = document.querySelector('.hero--has-image .hero__title .animation-contents');
    if (!el) return;
    var html = el.innerHTML;
    var m = html.match(/pro\s+([^<\s]+)\s*$/);
    if (!m) return;
    var st = document.createElement('style');
    st.textContent = '.tx-rot{display:inline-block;color:#e0b47a;position:relative;min-width:3ch;transition:opacity .35s ease,transform .35s ease}.tx-rot.is-out{opacity:0;transform:translateY(-18px)}.tx-rot.is-in{opacity:0;transform:translateY(18px)}.tx-rot::after{content:"";position:absolute;left:0;right:0;bottom:.05em;height:.08em;background:#a26b25;border-radius:4px}@media (prefers-reduced-motion:reduce){.tx-rot{transition:none}}';
    document.head.appendChild(st);
    el.innerHTML = html.replace(/pro\s+([^<\s]+)\s*$/, 'pro <span class="tx-rot" aria-live="off">' + m[1] + '</span>');
    var span = el.querySelector('.tx-rot');
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = Math.max(0, WORDS.indexOf(m[1]));
    setInterval(function () {
      i = (i + 1) % WORDS.length;
      span.classList.add('is-out');
      setTimeout(function () {
        span.textContent = WORDS[i];
        span.classList.remove('is-out');
        span.classList.add('is-in');
        requestAnimationFrame(function () { requestAnimationFrame(function () { span.classList.remove('is-in'); }); });
      }, 350);
    }, 2200);
  });
})();
